import {ABOUT_INFO_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getAboutInfo = (data) => ({
    type: ABOUT_INFO_LIST,
    payload: data
});